(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-recommendations')) {
    customElements.define(
      'product-recommendations',
      class extends HTMLElement {
        connectedCallback() {
          const root = this.closest('.product-recommendations');
          const hide = () => root && root.setAttribute('hidden', '');
          fetch(this.dataset.url)
            .then((response) => (response.ok ? response.text() : Promise.reject(new Error(response.status))))
            .then((html) => {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const fresh = doc.querySelector('product-recommendations');
              if (!fresh || !fresh.children.length) return hide();
              const style = doc.querySelector('style[data-section-stylesheet]');
              if (style) document.head.append(style);
              this.innerHTML = fresh.innerHTML;
              if (root) root.removeAttribute('hidden');
            })
            .catch(hide);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
